import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { APP_CONFIG } from '../../common/constants';
import { AppConfig } from '../../model/app-config.model';
import { ReportInput } from '../../power-bi/model/power-bi.model';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('titleDiv') titleDiv: ElementRef<HTMLElement>;
  powerBIConfig: ReportInput;
  reportUrl: string;
  constructor(@Inject(APP_CONFIG) appConfig: AppConfig) {
    this.powerBIConfig = appConfig.bamPowerBIReport;
    // this.powerBIConfig = appConfig.bamPowerBIReport;
    this.reportUrl = `https://msit.powerbi.com/groups/${this.powerBIConfig.groupId}/reports/${this.powerBIConfig.reportId}`;
  }

  ngAfterViewInit() {
    this.titleDiv.nativeElement.focus();
  }
}

